var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VExpansionPanels',{staticClass:"expansion-card"},[_c('VExpansionPanel',[_c('VExpansionPanelHeader',[_vm._t("header")],2),_c('VExpansionPanelContent',[_vm._t("content")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }